import React from 'react'
// TODO move ui
// import { Panorama } from '@brainstud/schiphol-vtc-ui'
import { Layout } from '../'

const PanoramaModal = props => (
  <Layout nospacing wide darkCloseButton style={{ width: '100%', maxWidth: '112rem' }}>
    {props.data && props.data.image &&
      <Panorama
        autoLoad
        showControls={false}
        height="600px"
        image={props.data && props.data.image} />
    }
  </Layout>
)

export default PanoramaModal
